import React, {memo} from "react"
import {useTranslation} from "react-i18next";
import {DateTimePicker} from "@mui/x-date-pickers";
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

import FormSection from "../../../components/FormSection";
import StationAutocomplete from "../../../components/inputs/StationsAutocomplete/StationAutocomplete";

import Grid from "@mui/material/Grid";
import MDInput from "materialDashboard/components/MDInput";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {formikPropertyEqual} from "./index";


const InfoSection = memo(({formik, warnings, inputDisabled}) => {
    const {t} = useTranslation(['models1', 'enums']);

    const datetimeChanged = formik.values.datetime !== formik.initialValues.datetime;

    return <FormSection title={t('model1Form.infoSection')}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            <Grid item xs={12} md={6}>
                <StationAutocomplete name="stationId"
                                     selectedStation={formik.values.station}
                                     setSelectedStation={(s) => formik.setFieldValue("station", s)}
                                     stationFilters={{
                                         accept_mod1: true,
                                         acl__model1_write: true,
                                     }}
                                     fieldProps={{
                                         error: formik.touched.station && Boolean(formik.errors.station),
                                         helperText: formik.touched.station && formik.errors.station || warnings.station,
                                         warning: Boolean(warnings.station)
                                     }}
                                     disabled={inputDisabled}/>
            </Grid>

            <Grid item xs={12} md={6}>
                <DateTimePicker value={formik.values.datetime}
                                label={t('model1Form.datetime')}
                                onChange={(date) => formik.setFieldValue("datetime", date)}
                                viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                }}
                                sx={{width: "100%"}}
                                slots={{
                                    // override default slots for better styling
                                    textField: MDInput
                                }}
                                slotProps={{
                                    textField: {
                                        variant: 'standard',
                                        error: formik.touched.datetime && Boolean(formik.errors.datetime),
                                        helperText: (formik.touched.datetime && formik.errors.datetime) || (!datetimeChanged && warnings.datetime),
                                        warning: !datetimeChanged && Boolean(warnings.datetime)
                                    }
                                }}
                                ampm={false}
                                disableFuture
                                disabled={inputDisabled}
                />
            </Grid>

            <Grid item xs={12}>
                <FormControl>
                    <RadioGroup name="period"
                                value={formik.values.period}
                                onChange={formik.handleChange}>
                        <FormControlLabel value="H24" control={<Radio size="small"/>}
                                          label={t('enums:model1Period.H24')}
                                          disabled={inputDisabled}/>
                        <FormControlLabel value="LT24H" control={<Radio size="small"/>}
                                          label={t('enums:model1Period.LT24H')}
                                          disabled={inputDisabled}/>
                        <FormControlLabel value="GT24H" control={<Radio size="small"/>}
                                          label={t('enums:model1Period.GT24H')}
                                          disabled={inputDisabled}/>
                    </RadioGroup>
                </FormControl>
            </Grid>
        </Grid>
    </FormSection>
}, (prevProps, nextProps) => formikPropertyEqual(prevProps, nextProps, ['station', 'datetime', 'period']));

export default InfoSection;